<template>
  <scoped>
    <table v-if="items">
      <thead>
        <tr>
          <th>
            Name
          </th>
          <th>
            Number
          </th>
          <th>
            Type
          </th>
        </tr>
      </thead>
      <tbody v-if="items.length > 0">
        <tr
          v-for="(customer, index) in items"
          :key="customer.id"
          :class="{'selected' : selectedIndex == index}"
          @click="select(index)"
        >
          <td>
            {{ customer.name }}
          </td>
          <td>
            {{ customer.number }}
          </td>
          <td>
            {{ customer.type }}
          </td>
        </tr>
      </tbody>
    </table>
  </scoped>
</template>

<script setup lang="ts">
  import {Customer} from "@/endpoints/rutsolve/gql/generated/graphql"
  import {nextTick} from "vue"

  defineProps({
    items: {
      default: null,
      required: true,
      type: Array<Customer>
    }
  })

  const emits = defineEmits([
    "select",
  ])

  const selectedIndex = defineModel("selectedIndex", {
    default: null,
    required: false,
    type: Number
  })

  async function select(index: number) {
    selectedIndex.value = index
    await nextTick()
    emits("select")
  }
</script>

<style scoped>
  table {
    > tbody {
      > tr {
        &:hover {
          background-color: var(--theme-color-secondary);
          color: var(--color-white);
          cursor: pointer;
        }
        
        &.selected {
          background-color: var(--theme-color-secondary);
          color: var(--color-white);
          cursor: default;
        }
      }
    }
  }
</style>
